import { render, staticRenderFns } from "./HistoryDetailHistoryLayout.vue?vue&type=template&id=23593a7f&scoped=true"
import script from "./HistoryDetailHistoryLayout.vue?vue&type=script&lang=js"
export * from "./HistoryDetailHistoryLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23593a7f",
  null
  
)

export default component.exports